import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { CheckmarkVerifiedIcon } from '@change/ds-icons/CheckmarkVerifiedIcon';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { PetitionDetails } from '#src/app/pages/petitionDetails/shared/types';

export const OrganizationLink: React.FC<{
	organization: NonNullable<PetitionDetails['organization']>;
}> = ({ organization }) => {
	const { translate } = useI18n();

	return (
		<Text variant="body" size="medium" fontWeight="bold" data-testid="petition-starter-organization" className="mb-1">
			{organization.name}
			{organization.verificationStatus === 'VERIFIED' ? (
				<CheckmarkVerifiedIcon
					size={14}
					className="text-icon-success"
					aria-label={translate('fe.pages.organization.verified_label')}
				/>
			) : null}
		</Text>
	);
};
